import React from 'react';

interface FitzaaLoaderProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
  theme?: any;
}

export const FitzaaLoader: React.FC<FitzaaLoaderProps> = ({ 
  size = 'medium', 
  message,
  theme 
}) => {
  const sizeClasses = {
    small: 'w-6 h-6',
    medium: 'w-12 h-12',
    large: 'w-16 h-16'
  };

  const textSizes = {
    small: 'text-sm',
    medium: 'text-base',
    large: 'text-lg'
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div className={`${sizeClasses[size]} relative`}>
        {/* Rotating Fitzaa logo */}
        <div className={`${sizeClasses[size]} animate-spin rounded-full border-2 border-transparent border-t-blue-600 flex items-center justify-center`}>
          <img 
            src="/appIcon.png" 
            alt="Fitzaa"
            className={`${size === 'small' ? 'w-4 h-4' : size === 'medium' ? 'w-6 h-6' : 'w-8 h-8'} opacity-50`}
          />
        </div>
        
        {/* Pulsing overlay */}
        <div className={`${sizeClasses[size]} absolute inset-0 animate-pulse rounded-full bg-blue-600 opacity-20`} />
      </div>
      
      {message && (
        <div className={`mt-3 text-center ${textSizes[size]} text-gray-600`}>
          {message}
        </div>
      )}
    </div>
  );
}; 